module.exports = __webpack_public_path__ + "static/fonts/BMEuljiro10yearslaterOTF.otf?cff03061";